import { render, staticRenderFns } from "./ShowMaterialRequirements.vue?vue&type=template&id=0c21a32d"
import script from "./ShowMaterialRequirements.vue?vue&type=script&lang=js"
export * from "./ShowMaterialRequirements.vue?vue&type=script&lang=js"
import style0 from "./ShowMaterialRequirements.vue?vue&type=style&index=0&id=0c21a32d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports